<script lang="ts">
    export let params: {
        userNameId: string
    }
</script>
Тут буде інформація про цей варіант імені цілі {params.userNameId}
